var React = require('react');

function MapBgShape (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 2"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Group-2","transform":"translate(0.072958, 0.408429)"},[React.createElement("polygon",{"id":"shadow","fill":"#BFBFBF","points":"0 23.052351 184.255125 170.485326 184.255125 365.014944 1167.99197 365.014944 1311.59977 719.202566 1311.59977 21 0 21","key":0}),React.createElement("polygon",{"id":"main-box","fill":"#E0CA59","points":"19 2.05235101 203.255125 149.485326 203.255125 344.014944 1186.99197 344.014944 1311.59977 675.452596 1311.59977 1.13686838e-13 19 1.13686838e-13","key":1})]))]);
}

MapBgShape.defaultProps = {"viewBox":"0 0 1312 720","version":"1.1"};

module.exports = MapBgShape;

MapBgShape.default = MapBgShape;
